import CompanyPositionComponent from "../components/CompanyPositionView";
import useCompanyPosition from "../hooks/usePosition";

function CompanyPosition(props) {
  const useCompanyPositionProps = useCompanyPosition(props);
  return <CompanyPositionComponent {...useCompanyPositionProps} />;
}

export default CompanyPosition;
